import { FC } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Stack, Image, Heading, Text } from "@chakra-ui/react";

import { RoutesMap } from "../../../../../routes.tsx";
import exclamationMarkIcon from "../../../../../assets/exclamationMark.png";
import { useSbpTransferStore } from "../../../../../store/sbpTransferStore.ts";

export const SbpTransferResultPageError: FC = () => {
  const navigate = useNavigate();

  const transferResult = useSbpTransferStore(s => s.transferResult);
  const setAmount = useSbpTransferStore(s => s.setAmount);
  const setTerm = useSbpTransferStore(s => s.setTerm);
  const setSelectedBankSchema = useSbpTransferStore(s => s.setSelectedBankSchema);

  const isRepeatAvailable = !!transferResult?.amount && !!transferResult.term && !!transferResult.bankSchema;

  const onRepeatClick = () => {
    if (!isRepeatAvailable) {
      return;
    }

    setAmount(transferResult.amount);
    setTerm(transferResult.term);
    setSelectedBankSchema(transferResult.bankSchema);

    navigate(RoutesMap.sbpTransfer.processing);
  };

  const onReturnHomeClick = () => {
    navigate(RoutesMap.index);
  };

  return (
    <Stack spacing={0} flex="1" alignItems="center" textAlign="center">
      <Image src={exclamationMarkIcon} boxSize="173px" mb="22px" />
      <Heading mb="8px">Перевод не выполнен</Heading>

      <Text fontSize="14px" mb="15px">Мы не смогли выполнить перевод сейчас</Text>
      <Text fontSize="14px" maxW="215px" mb="18px">
        Вы можете попробовать ещё раз через несколько минут
      </Text>

      {isRepeatAvailable && (
        <Button w="100%" colorScheme="brand" mb="6px" onClick={onRepeatClick}>
          Попробовать снова
        </Button>
      )}

      <Button w="100%" colorScheme="purple" onClick={onReturnHomeClick}>
        Вернуться на главную
      </Button>
    </Stack>
  );
};
